import { Text } from 'foundations-components/components/Text';
import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H1 } from 'foundations-components/transitional/components/H1';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LeftAlignTextDiv = styled.div.withConfig({
  displayName: "CoreSeatsExplainerModal__LeftAlignTextDiv",
  componentId: "sc-16hbe6x-0"
})(({
  theme
}) => ({
  textAlign: 'left',
  marginTop: theme.space['800']
}));
const CoreSeatsExplainerModal = ({
  handleModalClose,
  currencyCode,
  coreSeatProPrice
}) => {
  return /*#__PURE__*/_jsxs(Modal, {
    width: 600,
    use: "conversational",
    children: [/*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: handleModalClose
      })
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(H1, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'upgrades.coreSeatsExplainerModal.title'
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'upgrades.coreSeatsExplainerModal.description'
        })
      }), /*#__PURE__*/_jsxs(LeftAlignTextDiv, {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h4",
          marginBlockStart: "400",
          marginBlockEnd: "50",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'upgrades.coreSeatsExplainerModal.whatIsACoreSeat.title'
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'upgrades.coreSeatsExplainerModal.whatIsACoreSeat.description'
          })
        }), /*#__PURE__*/_jsx(Text, {
          as: "h4",
          marginBlockStart: "400",
          marginBlockEnd: "50",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'upgrades.coreSeatsExplainerModal.howAreCoreSeatsPriced.title'
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: 'upgrades.coreSeatsExplainerModal.howAreCoreSeatsPriced.description_jsx',
            elements: {
              FormattedCurrency: FormattedIntlCurrency
            },
            options: {
              value: coreSeatProPrice,
              currencyCode
            }
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(DialogFooter, {
      align: "center",
      children: /*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: handleModalClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'upgrades.coreSeatsExplainerModal.close'
        })
      })
    })]
  });
};
export default CoreSeatsExplainerModal;